<template>
  <section class="invoice" v-if="data">
    <div class="invoice-block">
      <div class="invoice-block-one invoice-title invoice-block-one__grow">
        Акт сдачи-приемки выполненных работ (оказанных услуг) №
        <span
          class="invoice-number"
          :class="{ 'number-empty': data.name == '' }"
          >{{ data.name }}</span
        >
        от {{ data.date | moment('DD.MM.YYYY')}}
      </div>
    </div>
    <div class="invoice-block">
      <div class="invoice-block-one invoice-block-one__small invoice-bold">
        {{ $root.app.types.find((x) => x.id == data.me.type).name }}
      </div>
      <div class="invoice-block-one invoice-block-one__grow">
        {{ company.name.full_with_opf }}, ИНН: {{ company.inn }},
        <span v-if="company.kpp">КПП:{{ company.kpp }},</span>
        <span
          >{{ company.inn.length == 10 ? "ОГРН" : "ОГРНИП" }}:
          {{ company.ogrn }},</span
        >
        Юридический адрес:
        {{ company.address.unrestricted_value }}
      </div>
    </div>
    <div class="invoice-block">
      <div class="invoice-block-one invoice-block-one__small invoice-bold">
        {{ $root.app.types_b.find((x) => x.id == data.customer.type).name }}
      </div>
      <div class="invoice-block-one invoice-block-one__grow">
        {{ data.customer.data.name.full_with_opf }}, ИНН:
        {{ data.customer.data.inn }},
        <span v-if="data.customer.data.kpp"
          >КПП:{{ data.customer.data.kpp }},</span
        >
        <span
          >{{ company.inn.length == 10 ? "ОГРН" : "ОГРНИП" }}:
          {{ data.customer.data.ogrn }},</span
        >
        Юридический адрес: {{ data.customer.data.address.unrestricted_value }}
      </div>
    </div>


    <div class="invoice-block">
      <div class="invoice-items">
        <div class="invoice-items-one invoice-items-one__title">
          <div class="invoice-items-elem invoice-items-elem__index">№</div>
          <div class="invoice-items-elem invoice-items-elem__name">
            Наименование товаров, работ, услуг
          </div>
          <div class="invoice-items-elem invoice-items-elem__count">Кол-во</div>
          <div class="invoice-items-elem invoice-items-elem__counttype">
            Ед. изм
          </div>
          <div class="invoice-items-elem invoice-items-elem__cost">Цена</div>
          <div class="invoice-items-elem invoice-items-elem__sum">Всего</div>
        </div>
        <div
          class="invoice-items-one"
          v-for="(elem, index) in data.items"
          :key="elem.id"
        >
          <div class="invoice-items-elem invoice-items-elem__index">
            {{ index + 1 }}
          </div>
          <div class="invoice-items-elem invoice-items-elem__name">
            {{ elem.name }}
          </div>
          <div class="invoice-items-elem invoice-items-elem__count">
            {{ elem.count }}
          </div>
          <div class="invoice-items-elem invoice-items-elem__counttype">
            {{ elem.type }}
          </div>
          <div class="invoice-items-elem invoice-items-elem__cost">
            {{ elem.cost | money }}
          </div>
          <div class="invoice-items-elem invoice-items-elem__sum">
            {{ (elem.cost * elem.count) | money }}
          </div>
        </div>
        <div
          class="invoice-items-one invoice-items-finally"
          v-if="$root.app.user.nds == '1'"
        >
          <div class="invoice-items-elem invoice-items-elem__title">Итого</div>
          <div class="invoice-items-elem invoice-items-elem__sum">
            {{ sum | money }}
          </div>
        </div>
        <div class="invoice-nds-lines" v-if="$root.app.user.nds == '1'">
          <div
            class="invoice-items-one invoice-items-finally"
            v-for="el in nds_data"
            :key="el.id"
          >
            <div class="invoice-items-elem invoice-items-elem__title">
              В том числе НДС {{ el.id }}%
            </div>
            <div class="invoice-items-elem invoice-items-elem__sum">
              {{ el.sum | money }}
            </div>
          </div>
        </div>
        <div class="invoice-items-one invoice-items-finally">
          <div class="invoice-items-elem invoice-items-elem__title">
            Итого к оплате
          </div>
          <div class="invoice-items-elem invoice-items-elem__sum">
            {{ ((data.nds == "0" ? nds : 0) + sum) | money }}
          </div>
        </div>
      </div>
    </div>

    <div class="invoice-block invoice-bottom">
      <div class="text-left">
        Всего оказано услуг {{ data.items.length }} на сумму {{ sum_b }} рублей
        {{ sum_k < 10 ? "0" + sum_k : sum_k }} копеек<br/>
        <strong>{{ sum_text }}</strong>
        <div class="sum-text-label" v-if="$root.app.user.nds == '0'">
          <strong>{{ $root.app.user.nds_reason }}</strong>
        </div>
        <br/><br/>
        Вышеперечисленные услуги выполнены полностью и в срок. 
        Заказчик претензий по объему, качеству и срокам оказания услуг не имеет.
      </div>
    </div>
    <div class="invoice-block invoice-signatures">
        <div class="signature-one">
            <div class="signature-title">{{ $root.app.types.find((x) => x.id == data.me.type).name }}</div>
            <div class="signature-line">
                <div class="signature-line__value">{{ data.post_me }}</div>
                <div class="signature-line__label">Должность</div>
            </div>
            <div class="signature-line__group">
                <div class="signature-line">
                  <div class="signature-line__value"></div>
                  <div class="signature-line__label">Подпись</div>
                </div>
                <div class="signature-line">
                  <div class="signature-line__value">{{ data.post_name_me | fullToShort }}</div>
                  <div class="signature-line__label">Расшифровка подписи</div>
                </div>
            </div>
                <div class="signature-line signature-line__stamp">
                  M.П.
                </div>
        </div>

         <div class="signature-one">
            <div class="signature-title">{{ $root.app.types_b.find((x) => x.id == data.customer.type).name }}</div>
            <div class="signature-line">
                <div class="signature-line__value">{{ data.post }}</div>
                <div class="signature-line__label">Должность</div>
            </div>
            <div class="signature-line__group">
                <div class="signature-line">
                  <div class="signature-line__value"></div>
                  <div class="signature-line__label">Подпись</div>
                </div>
                <div class="signature-line">
                  <div class="signature-line__value">{{ data.post_name | fullToShort }}</div>
                  <div class="signature-line__label">Расшифровка подписи</div>
                </div>
            </div>
                <div class="signature-line signature-line__stamp">
                  M.П.
                </div>
        </div>

    </div>

  </section>
</template>

<script>
import { rubles } from "rubles";

export default {
  props: ["data"],
  name: "InvoiceActs",
  methods: {},
  computed: {
    company: function () {
      if (!this.data.me.inn) return this.$root.app.user.data;
      return this.data.me.data;
    },
    bank: function () {
      if (!this.data.me.bank.current) return this.$root.app.user.bank;
      return this.data.me.bank;
    },
    sum: function () {
      var sum = 0;
      this.data.items.forEach((el) => {
        sum += el.cost * el.count;
      });

      return sum;
    },
    sum_b: function () {
      return Math.floor((this.data.nds == "0" ? this.nds : 0) + this.sum);
    },
    sum_k: function () {
      return Math.floor(
        ((this.data.nds == "0" ? this.nds : 0) + this.sum - this.sum_b) * 100
      );
    },
    nds: function () {
      let nds = 0;
      if (this.$root.app.user.nds == "0") return 0;

      this.data.items.forEach((el) => {
        let sum = el.count * el.cost,
          nds_value = this.$root.app.nds_types.find((x) => x.id == el.nds)
            .value,
          d = this.data.nds == "1" ? nds_value : 0;

        nds += (sum * nds_value) / (d + 100);
      });

      return nds;
    },
    nds_data: function () {
      let nds = [];
      if (this.$root.app.user.nds == "0") return 0;

      this.data.items.forEach((el) => {
        let sum = el.count * el.cost,
          nds_value = this.$root.app.nds_types.find((x) => x.id == el.nds)
            .value,
          d = this.data.nds == "1" ? nds_value : 0;
        if (!nds.find((x) => x.id == nds_value))
          nds.push({ id: nds_value, sum: 0 });

        nds.find((x) => x.id == nds_value).sum += (sum * nds_value) / (d + 100);
      });

      return nds;
    },
    sum_text: function () {
      return this.sum == 0
        ? "Ноль рублей 00 копеек"
        : rubles((this.data.nds == "0" ? this.nds : 0) + this.sum);
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style  lang="scss">

</style>
